/* ==========================================================================
   TRFU hero carousel

   Replaces the inline script that used to live in sections/hero-rugby_2.liquid.
   Config comes off the section root as data attributes, so one file drives
   every hero on the site and the section stays small.

   WCAG 2.2.2 Pause Stop Hide, Level A. The old version:
     - autoplayed every 6s with no pause, stop or hide mechanism anywhere,
     - ignored prefers-reduced-motion entirely,
     - paused on mouseenter only, which never fires on touch and never fires
       for a keyboard user.
   This version ships a visible 44x44px pause and play button, never autoplays
   when the device asks for reduced motion, and holds on focus as well as hover.
   ========================================================================== */
(function () {
  'use strict';

  var motionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.trfu-hero-show__slide'));
    var total = slides.length;
    if (total < 2) return;

    var AUTOPLAY_MS   = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 6000;
    var AUTOPLAY_ON   = root.getAttribute('data-autoplay') === '1';
    var PAUSE_HOVER   = root.getAttribute('data-pause-hover') === '1';
    var SHOW_DOTS     = root.getAttribute('data-show-dots') === '1';
    var SHOW_PROGRESS = root.getAttribute('data-show-progress') === '1';
    var ACCENT        = root.getAttribute('data-accent') || '#ffb71b';

    var sectionId   = root.id.replace('trfu-hero-', '');
    var dots        = Array.prototype.slice.call(root.querySelectorAll('.trfu-hero-show__dot'));
    var prevBtn     = root.querySelector('.trfu-hero-show__arrow--prev');
    var nextBtn     = root.querySelector('.trfu-hero-show__arrow--next');
    var progressBar = document.getElementById('trfu-progress-' + sectionId);
    var toggleBtn   = document.getElementById('trfu-toggle-' + sectionId);
    var iconPause   = toggleBtn ? toggleBtn.querySelector('.trfu-hero-show__icon-pause') : null;
    var iconPlay    = toggleBtn ? toggleBtn.querySelector('.trfu-hero-show__icon-play') : null;

    var current = 0;
    var timer = null;

    var reducedMotion   = motionQuery ? motionQuery.matches : false;
    var autoplayAllowed = AUTOPLAY_ON && !reducedMotion;
    var userPaused      = !autoplayAllowed;
    var transientPause  = false;

    function isPlaying() { return timer !== null; }

    function restartProgress() {
      if (!SHOW_PROGRESS || !progressBar) return;
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      if (!isPlaying()) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!isPlaying()) return;
          progressBar.style.transition = 'width ' + (AUTOPLAY_MS / 1000) + 's linear';
          progressBar.style.width = '100%';
        });
      });
    }

    function goTo(index) {
      var prev = current;
      current = ((index % total) + total) % total;

      slides[prev].style.opacity = '0';
      slides[prev].style.pointerEvents = 'none';
      slides[prev].style.zIndex = '0';

      slides[current].style.opacity = '1';
      slides[current].style.pointerEvents = 'auto';
      slides[current].style.zIndex = '1';

      if (SHOW_DOTS) {
        dots.forEach(function (dot, i) {
          var on = (i === current);
          dot.style.width = on ? '24px' : '8px';
          dot.style.background = on ? ACCENT : 'rgba(255,255,255,0.6)';
          if (on) { dot.setAttribute('aria-current', 'true'); }
          else { dot.removeAttribute('aria-current'); }
        });
      }
      restartProgress();
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
      if (SHOW_PROGRESS && progressBar && progressBar.parentNode) {
        var filled = progressBar.getBoundingClientRect().width;
        var track = progressBar.parentNode.getBoundingClientRect().width;
        progressBar.style.transition = 'none';
        progressBar.style.width = track ? ((filled / track) * 100) + '%' : '0%';
      }
    }

    function startTimer() {
      stopTimer();
      if (!autoplayAllowed || userPaused || transientPause) return;
      timer = setInterval(function () { goTo(current + 1); }, AUTOPLAY_MS);
      restartProgress();
    }

    function syncToggle() {
      if (!toggleBtn) return;
      var paused = !isPlaying();
      toggleBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      toggleBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (iconPause) iconPause.style.display = paused ? 'none' : '';
      if (iconPlay) iconPlay.style.display = paused ? '' : 'none';
    }

    function play() { userPaused = false; transientPause = false; startTimer(); syncToggle(); }
    function pause() { userPaused = true; stopTimer(); syncToggle(); }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        if (isPlaying()) { pause(); } else { play(); }
      });
    }

    function step(delta) { goTo(current + delta); startTimer(); syncToggle(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-slide'), 10));
        startTimer();
        syncToggle();
      });
    });

    /* Hold on hover AND on focus. focusin/focusout is what the old code was
       missing, so a keyboard user tabbing into a hero link had the slide
       change underneath them. */
    function hold() {
      if (!autoplayAllowed || userPaused) return;
      transientPause = true;
      stopTimer();
      syncToggle();
    }
    function release() {
      if (!autoplayAllowed || userPaused) return;
      if (root.contains(document.activeElement) && document.activeElement !== document.body) return;
      if (root.matches(':hover')) return;
      transientPause = false;
      startTimer();
      syncToggle();
    }

    if (PAUSE_HOVER) {
      root.addEventListener('mouseenter', hold);
      root.addEventListener('mouseleave', release);
    }
    root.addEventListener('focusin', hold);
    root.addEventListener('focusout', release);

    var touchStartX = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      var delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) { step(delta > 0 ? 1 : -1); }
    }, { passive: true });

    root.setAttribute('tabindex', '-1');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });

    function onMotionChange() {
      reducedMotion = motionQuery.matches;
      autoplayAllowed = AUTOPLAY_ON && !reducedMotion;
      if (!autoplayAllowed) { pause(); } else { startTimer(); syncToggle(); }
    }
    if (motionQuery) {
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
      else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
    }

    goTo(0);
    startTimer();
    syncToggle();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-trfu-hero]')).forEach(function (root) {
      if (root.hasAttribute('data-trfu-hero-ready')) return;
      root.setAttribute('data-trfu-hero-ready', '1');
      initHero(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
}());
